import React from "react";
import PropTypes from "prop-types";
import MuiAvatar from "@mui/material/Avatar";
import isString from "lodash-es/isString";
import isFunction from "lodash-es/isFunction";
import merge from "lodash-es/merge";

const Avatar = (props) => {
  const { Icon, color, textColor, ...otherProps } = props;

  const renderAvatarContent = () => {
    if (isFunction(Icon)) {
      return <Icon width={20} heigth={20} />;
    }
    if (isString(Icon)) {
      return Icon.charAt(0).toUpperCase();
    }
  };
  const avatarSx = { fontSize: "14px" };

  if (color) avatarSx.bgcolor = color;
  if (textColor) avatarSx.color = textColor;

  return (
    <MuiAvatar {...merge({ sx: avatarSx }, otherProps)}>
      {renderAvatarContent()}
    </MuiAvatar>
  );
};

Avatar.propTypes = {
  Icon: PropTypes.oneOfType([PropTypes.elementType, PropTypes.string]),
  className: PropTypes.string,
  variant: PropTypes.oneOf(["circular", "rounded", "square"]),
  color: PropTypes.string,
  textColor: PropTypes.string,
};

export default Avatar;
